import styled from 'styled-components'

export default styled.div`
    display:flex;
    flex-direction: row;
    align-items:center;
    font-family: "Poppins";
`